// const Url = "http://193.203.160.181:5059/"
const Url = "https://api.jaininternationalnetwork.com/"

export const URLS = {
  Base: Url,

  //profile
  getProfile: Url + "v1/a2zsolutionsapi/admin/auth/getadminprofile",
  UpdateProfile: Url + "v1/a2zsolutionsapi/admin/auth/editprofile",
  UpdateProfileImage: Url + "v1/a2zsolutionsapi/admin/auth/editprofilepic",
  ChangePass: Url + "v1/a2zsolutionsapi/admin/auth/changepass",

  //Department
  AddDepartment: Url + "v1/a2zsolutionsapi/admin/department/adddepartment",
  GetDepartment: Url + "v1/a2zsolutionsapi/admin/department/getdepartments",
  GetDepartmentSearch:
    Url + "v1/a2zsolutionsapi/admin/department/getdepartments?searchQuery=",
  UpdateDepartment: Url + "v1/a2zsolutionsapi/admin/department/editdepartment",
  InActiveDepartment:
    Url + "v1/a2zsolutionsapi/admin/department/deletedepartment",

  //Role
  AddRole: Url + "v1/a2zsolutionsapi/admin/role/addrole",
  GetRole: Url + "v1/a2zsolutionsapi/admin/role/getAll",
  GetRoleSearch: Url + "v1/a2zsolutionsapi/admin/role/getAll?searchQuery=",
  GetOneRole: Url + "v1/a2zsolutionsapi/admin/role/getrole",
  EditRole: Url + "v1/a2zsolutionsapi/admin/role/editrole",
  DeleteRole: Url + "v1/a2zsolutionsapi/admin/role/deleterole/",

  //Staff
  AddStaff: Url + "v1/a2zsolutionsapi/admin/staff/addstaff",
  GetStaff: Url + "v1/a2zsolutionsapi/admin/staff/getAllstaff",
  GetStaffSearch:
    Url + "v1/a2zsolutionsapi/admin/staff/getAllstaff?searchQuery=",
  EditStaff: Url + "v1/a2zsolutionsapi/admin/staff/editstaff/",
  DeleteStaff: Url + "v1/a2zsolutionsapi/admin/staff/deletestaff/",

  //Agent
  Addagent: Url + "v1/a2zsolutionsapi/admin/agent/addAgent",
  Getagent: Url + "v1/a2zsolutionsapi/admin/agent/getAgents",
  GetagentSearch:
    Url + "v1/a2zsolutionsapi/admin/agent/getAgents?searchQuery=",
  Editagent: Url + "v1/a2zsolutionsapi/admin/agent/editAgent/",
  Deleteagent: Url + "v1/a2zsolutionsapi/admin/agent/deleteAgent/",
  Agentbyid: Url + "v1/a2zsolutionsapi/admin/agent/getAgentById/",

  //Banner
  AddBanners: Url + "v1/a2zsolutionsapi/admin/banner/addbanner",
  UpdateBanners: Url + "v1/a2zsolutionsapi/admin/banner/editbanner/",
  InActiveBanners: Url + "v1/a2zsolutionsapi/admin/banner/deletebanner/",
  GetBanners: Url + "v1/a2zsolutionsapi/admin/banner/getALL",
  GetBannersSearch: Url + "v1/a2zsolutionsapi/admin/banner/getALL?searchQuery=",

  //Product category
  AddProductcategory: Url + "v1/a2zsolutionsapi/admin/saleCategories/addcategory",
  UpdateProductcategory: Url + "v1/a2zsolutionsapi/admin/saleCategories/editcategory/",
  InActiveProductcategory: Url + "v1/a2zsolutionsapi/admin/saleCategories/deletecategory/",
  GetProductcategory: Url + "v1/a2zsolutionsapi/admin/saleCategories/getallcategorys",
  GetProductcategorySearch: Url + "v1/a2zsolutionsapi/admin/saleCategories/getallcategorys?searchQuery=",

  // Product list
  GetProduct: Url + "v1/a2zsolutionsapi/admin/saleCategories/getAllproducts",
  EditPriorityStatus: Url + "v1/a2zsolutionsapi/admin/saleCategories/editPriorityStatus/",
  DeleteProduct: Url + "v1/a2zsolutionsapi/admin/saleCategories/deleteProduct/",
  GetProductSearch: Url + "v1/a2zsolutionsapi/admin/saleCategories/getAllproducts?searchQuery=",

  //Settings
  GetSetting: Url + "v1/a2zsolutionsapi/admin/policies/getpolicies",
  Updateprivacypolicy:
    Url + "v1/a2zsolutionsapi/admin/policies/updateprivacypolicy",
  Updatetermsandcondition:
    Url + "v1/a2zsolutionsapi/admin/policies/updatetermsandcondition",

  //Contact
  GetContact: Url + "v1/a2zsolutionsapi/admin/contactus/getcontactus",
  UpdateContact: Url + "v1/a2zsolutionsapi/admin/contactus/editcontactus",

  //Notification
  GetNotifications: Url + "getNotifications",
  AddNotifications: Url + "sendNotifications",
  DeleteNotifications: Url + "deleteNotification",

  GetDashboad: Url + "dashboardCount",

  //Category
  AddCategory: Url + "v1/a2zsolutionsapi/admin/category/addcategory",
  GetCategory: Url + "v1/a2zsolutionsapi/admin/category/getallcategorys",
  GetCategorySearch:
    Url + "v1/a2zsolutionsapi/admin/category/getallcategorys?searchQuery=",
  EditCategory: Url + "v1/a2zsolutionsapi/admin/category/editcategory/",
  DeleteCategory: Url + "v1/a2zsolutionsapi/admin/category/deletecategory/",
  GetCategoryId:
    Url + "v1/a2zsolutionsapi/admin/subcategory/category/categorybyid",

  //Template Category
  AddTemplateCategory:
    Url + "v1/a2zsolutionsapi/admin/templatecategory/addtemplatecategory",
  GetTemplateCategory:
    Url + "v1/a2zsolutionsapi/admin/templatecategory/getalltemplatecategory",
  GetTemplateCategorySearch:
    Url +
    "v1/a2zsolutionsapi/admin/templatecategory/getalltemplatecategory?SearchQuery=",
  EditTemplateCategory:
    Url + "v1/a2zsolutionsapi/admin/templatecategory/edittemplatecategory/",
  DeleteTemplateCategory:
    Url + "v1/a2zsolutionsapi/admin/templatecategory/deletetemplatecategory/",

  //Templates
  AddTemplates: Url + "v1/a2zsolutionsapi/admin/template/addtemplate",
  GetTemplates: Url + "v1/a2zsolutionsapi/admin/template/getalltemplates",
  GetTemplatesSearch:
    Url + "v1/a2zsolutionsapi/admin/template/getalltemplates?searchQuery=",
  EditTemplates: Url + "v1/a2zsolutionsapi/admin/template/edittemplate/",
  DeleteTemplates: Url + "v1/a2zsolutionsapi/admin/template/deletetemplate/",

  //SubCategory
  AddSubCategory: Url + "v1/a2zsolutionsapi/admin/subcategory/addsubcategory",
  GetSubCategory:
    Url + "v1/a2zsolutionsapi/admin/subcategory/getallsubcategorys",
  GetSubCategorySearch:
    Url +
    "v1/a2zsolutionsapi/admin/subcategory/getallsubcategorys?searchQuery=",
  EditSubCategory:
    Url + "v1/a2zsolutionsapi/admin/subcategory/editsubcategory/",
  DeleteSubCategory:
    Url + "v1/a2zsolutionsapi/admin/subcategory/deletesubcategory/",
  GetSubCategoryId:
    Url + "v1/a2zsolutionsapi/admin/subcategory/category/categorybyid",

  //Facilities
  AddFacilities: Url + "v1/a2zsolutionsapi/admin/facilities/addFacility",
  GetFacilities:
    Url + "v1/a2zsolutionsapi/admin/facilities/getalladminfacilities",
  GetFacilitiesSearch:
    Url +
    "v1/a2zsolutionsapi/admin/facilities/getalladminfacilities?searchQuery=",
  EditFacilities: Url + "v1/a2zsolutionsapi/admin/facilities/editFacility/",
  DeleteFacilities: Url + "v1/a2zsolutionsapi/admin/facilities/deleteFacility/",
  GetFacilitiesId:
    Url + "v1/a2zsolutionsapi/admin/facilities/getsubcategorybyid",

  //Contact Us
  GetContactUs: Url + "v1/a2zsolutionsapi/admin/contactus/getcontactus",
  UpdateContactUs: Url + "v1/a2zsolutionsapi/admin/contactus/editcontactus",

  //Listing
  AddListing: Url + "v1/a2zsolutionsapi/admin/service/updateService",
  GetListing: Url + "v1/a2zsolutionsapi/admin/service/getallservices",
  GetListingSearch:
    Url + "v1/a2zsolutionsapi/admin/service/getallservices?searchQuery=",
  EditListing: Url + "v1/a2zsolutionsapi/admin/service/updateService",
  DeleteListing: Url + "v1/a2zsolutionsapi/admin/template/deletetemplate/",
  GetByIdListing: Url + "v1/a2zsolutionsapi/admin/service/getservicebyid",

  //VendorPlans
  AddVendorPlans: Url + "v1/a2zsolutionsapi/admin/subscription/addsubscription",
  GetVendorPlans:
    Url + "v1/a2zsolutionsapi/admin/subscription/getallsubscriptions",
  GetVendorPlansSearch:
    Url +
    "v1/a2zsolutionsapi/admin/subscription/getallsubscriptions?searchQuery=",
  EditVendorPlans:
    Url + "v1/a2zsolutionsapi/admin/subscription/editsubscription/",
  DeleteVendorPlans:
    Url + "v1/a2zsolutionsapi/admin/subscription/deletesubscription/",
  GetByIdVendorPlans:
    Url + "v1/a2zsolutionsapi/admin/subscription/getsubscriptionbyid",

  //Userlist
  GetUserlist: Url + "v1/a2zsolutionsapi/admin/getuserlist",
  GetIdUserlist: Url + "v1/a2zsolutionsapi/admin/getuserlistbyid",
  GetUserSearch: Url + "v1/a2zsolutionsapi/admin/getuserlist?searchQuery=",
  GetIdUserBlock: Url + "v1/a2zsolutionsapi/admin/updateuserstatus",

  //PendingUserListing
  PendingUserListing: Url + "v1/a2zsolutionsapi/admin/pendinguserlisting",
  PendingUserListingSearch:
    Url + "v1/a2zsolutionsapi/admin/pendinguserlisting?searchQuery=",
  UpdateUserListing:
    Url + "v1/a2zsolutionsapi/admin/service/listingStatusUpdate",
  CompletedUserListing: Url + "v1/a2zsolutionsapi/admin/completeduserlisting",
  CompletedUserListingSearch:
    Url + "v1/a2zsolutionsapi/admin/completeduserlisting?searchQuery=",
  //RejectedUserListing
  RejectedUserListing:
    Url + "v1/a2zsolutionsapi/admin/listing/rejecteduserlistings",
  RejectedUserListingSearch:
    Url + "v1/a2zsolutionsapi/admin/listing/rejecteduserlistings?searchQuery=",

  //PendingVendorListing
  PendingVendorListing:
    Url + "v1/a2zsolutionsapi/admin/vendor/getpendingvendorlist",
  PendingVendorListingSearch:
    Url + "v1/a2zsolutionsapi/admin/vendor/getpendingvendorlist?searchQuery=",
  UpdateVendorListing:
    Url + "v1/a2zsolutionsapi/admin/service/listingStatusUpdate",
  CompletedVendorListing:
    Url + "v1/a2zsolutionsapi/admin/vendor/getcompletedvendorlist",
  CompletedVendorListingSearch:
    Url + "v1/a2zsolutionsapi/admin/vendor/getcompletedvendorlist?searchQuery=",
  //RejectedVendorListing
  RejectedVendorListing:
    Url + "v1/a2zsolutionsapi/admin/listing/vendorrejectedlistings",
  RejectedVendorListingSearch:
    Url +
    "v1/a2zsolutionsapi/admin/listing/vendorrejectedlistings?searchQuery=",

  //RejectListing
  RejectListing: Url + "v1/a2zsolutionsapi/admin/listing/rejected/",

  //Vendor
  GetPendingVendor: Url + "v1/a2zsolutionsapi/admin/getpendingvendors",
  GetPendingSearchVendor:
    Url + "v1/a2zsolutionsapi/admin/getpendingvendors?searchQuery=",
  GetVendor: Url + "v1/a2zsolutionsapi/admin/vendor/getvendorlist",
  GetVendorSearch:
    Url + "v1/a2zsolutionsapi/admin/vendor/getvendorlist?searchQuery=",
  GetIdVendor: Url + "v1/a2zsolutionsapi/admin/vendor/getvendorlistbyid",
  VendorBlock: Url + "v1/a2zsolutionsapi/admin/updateuserstatus",

  GetRejectedVendor: Url + "v1/a2zsolutionsapi/admin/vendor/rejectedvendors",
  GetRejectedSearchVendor:
    Url + "v1/a2zsolutionsapi/admin/vendor/rejectedvendors?searchQuery=",

  GetPlanId: Url + "v1/a2zsolutionsapi/admin/subscribe/getsubscribebyid",
  GetPlanIdSearch:
    Url + "v1/a2zsolutionsapi/admin/subscribe/getsubscribebyid?searchQuery=",
  GetPlanPayments: Url + "v1/a2zsolutionsapi/admin/getpaymentslist",
  GetPlanPaymentsSearch:
    Url + "v1/a2zsolutionsapi/admin/getpaymentslist?searchQuery=",

  VendorStatusUpadate: Url + "v1/a2zsolutionsapi/admin/updateToapproved",
  VendorStatusRejected: Url + "v1/a2zsolutionsapi/admin/vendor/reject",
  VendorBlockUpadate: Url + "v1/a2zsolutionsapi/admin/updatevendorstatus",

  //Support
  GetSupport: Url + "v1/a2zsolutionsapi/admin/usersupports",
  GetSupportSearch: Url + "v1/a2zsolutionsapi/admin/usersupports?searchQuery=",
  UpdateSupport: Url + "v1/a2zsolutionsapi/admin/usersupport/updatestatus/",

  //Notification
  GetNotifications:
    Url + "v1/a2zsolutionsapi/admin/notification/getallnotifications",
  AddNotifications:
    Url + "v1/a2zsolutionsapi/admin/notification/addnotification",
  DeleteNotifications:
    Url + "v1/a2zsolutionsapi/admin/notification/deletenotification/",
  DeleteWhatsappNotifications:
    Url + "v1/a2zsolutionsapi/admin/notification/deletewhatsappnotification/",

  //Dashboard
  GetDashboard: Url + "v1/a2zsolutionsapi/admin/getadmindashboard",

  //Recharge
  GetRecharge: Url + "v1/a2zsolutionsapi/admin/getrechargehistory",
  GetRechargeSearch:
    Url + "v1/a2zsolutionsapi/admin/getrechargehistory?searchQuery=",
  GetOneRecharge: Url + "v1/a2zsolutionsapi/admin/getrechargehistorybyid",

  //UserCount
  GetUserCount:
    Url + "v1/a2zsolutionsapi/admin/postandlisting/getpostandlistingcount",
  UpdateUserCount:
    Url +
    "v1/a2zsolutionsapi/admin/postandlisting/updatepostcountandlistingcount",

  //Posters
  GetPosters: Url + "v1/a2zsolutionsapi/admin/post/allposts",
  DeletePosters: Url + "v1/a2zsolutionsapi/admin/post/deletepost/",
}
